import React from 'react';
import { MdEmail } from 'react-icons/md';

interface EmailProfileViewProps {
  fromName: string;
  fromEmail: string;
}

const EmailProfileView: React.FC<EmailProfileViewProps> = ({ fromName, fromEmail }) => {
  return (
    <div className="bg-[#2a2a2a] rounded-2xl border border-gray-700 p-8">
      <div className="text-center mb-6">
        <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-red-500 to-orange-600 flex items-center justify-center">
          <MdEmail size={40} className="text-white" />
        </div>
        <h2 className="text-white text-2xl font-semibold mb-2">Email Connected</h2>
        <p className="text-gray-400 text-sm">Your email integration is active and ready to send campaigns</p>
      </div>

      <div className="space-y-4">
        <div className="bg-[#1a1a1a] rounded-xl p-4 border border-gray-700">
          <p className="text-gray-400 text-xs mb-1">From Name</p>
          <p className="text-white text-lg font-medium">{fromName}</p>
        </div>

        <div className="bg-[#1a1a1a] rounded-xl p-4 border border-gray-700">
          <p className="text-gray-400 text-xs mb-1">From Email</p>
          <p className="text-white text-lg font-medium">{fromEmail}</p>
        </div>
      </div>
    </div>
  );
};

export default EmailProfileView;
